// Shared office contact constants for the A ONE admin app.

export const OFFICE_EMAIL = 'aone@a-oneinstitute.com';
